import React, { FC } from "react";
import { ProposalType, SettingType } from "../../app/types/ProposalTypes";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import moment from "moment";

interface ContactCardProps {
  proposalSettings: { proposal: ProposalType; settings: SettingType };
}

const ContactCard: FC<ContactCardProps> = ({ proposalSettings }) => {
  const { locale } = useSelector((state: RootState) => state.generalSettings);
  const headerClassname = "text-lg font-semibold ";
  const restClassname = "text-sm font-normal ";

  return (
    <>
      <div className="flex flex-col gap-2">
        <span className={headerClassname}>
          {globalThis.translate.em.proposal.signature_page.company_premises}
        </span>
        <span className={restClassname}>
          {proposalSettings.proposal.rooms
            .map((room) => room.name[locale])
            .join(",")}
        </span>
        <span className={restClassname}>
          {moment(proposalSettings.proposal.date)
            .locale(locale)
            .format("dddd, DD MMMM YYYY")}
        </span>
        <span className={restClassname}>
          {proposalSettings.proposal.guests}{" "}
          {globalThis.translate.em.proposal.signature_page.persons}
        </span>
      </div>
      {proposalSettings.proposal.customer && (
        <div className="flex flex-col gap-2">
          <span className={headerClassname}>
            {
              globalThis.translate.em.proposal.signature_page
                .contact_information
            }
          </span>
          <span className="text-sm font-normal">
            {proposalSettings.proposal.customer.c_fname}{" "}
            {proposalSettings.proposal.customer.c_lname}
          </span>
          <span className={restClassname + " underline"}>
            {proposalSettings.proposal.customer.c_email}
          </span>
          <span className={restClassname}>
            {proposalSettings.proposal.customer.c_phone}
          </span>
          <span className={restClassname}>
            {proposalSettings.proposal.company?.name}
          </span>
        </div>
      )}
      <div className="flex flex-row justify-between  text-[18px] gap-2">
        <div className="w-[50%] h-10 flex items-center">
          {globalThis.translate.em.proposal.contact_card.status}
        </div>
        <div className="w-[50%] bg-[#FFF9E2] h-10 rounded-[40px] flex justify-center items-center">
          {proposalSettings.proposal.sign_status}
        </div>
      </div>
    </>
  );
};

export default ContactCard;
